export default __webpack_public_path__ + "static/media/100-credits.9013eb8f.png";